export const getFlexibleDateMinPrice = (state) => state.flexibleDateMinPrice.flexibleDateMinPrice || [];
export const getFlexibleDateMinPriceSlice = (state) => state.flexibleDateMinPrice;
export const getFlexDateMinPriceFetchStatus = (state) => state.flexibleDateMinPrice.fetchStatus;
